class LangService {

    constructor($http,$window) {
        this.current = null;
        this.requestUrl = '/i18n/setlang/';
        this.http = $http;
        this.$window = $window;
        this.availableLanguages = ['uk', 'en'];
    }

    getCurrentLang() {
        return this.availableLanguages.indexOf(this.$window.CURRENT_LANG) !== -1
            ? this.$window.CURRENT_LANG
            : 'uk';
    }

    setCurrentLang(lang) {
        if (this.availableLanguages.indexOf(lang) === -1) {
            lang = 'uk';
        }

        let formData = new FormData();
        formData.append("language", lang);
        return this.http({
            method: 'POST',
            url: this.requestUrl,
            headers: {
                'Content-Type': undefined
            },
            data: formData
        });
    }
}

commons.service('langService', LangService);
